var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrossRed2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.35 0.661511C14.895 0.206511 14.16 0.206511 13.705 0.661511L7.99997 6.35484L2.29497 0.649844C1.83997 0.194844 1.10497 0.194844 0.649966 0.649844C0.194966 1.10484 0.194966 1.83984 0.649966 2.29484L6.35497 7.99984L0.649966 13.7048C0.194966 14.1598 0.194966 14.8948 0.649966 15.3498C1.10497 15.8048 1.83997 15.8048 2.29497 15.3498L7.99997 9.64484L13.705 15.3498C14.16 15.8048 14.895 15.8048 15.35 15.3498C15.805 14.8948 15.805 14.1598 15.35 13.7048L9.64497 7.99984L15.35 2.29484C15.7933 1.85151 15.7933 1.10484 15.35 0.661511Z",
    fill: "#F44336"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossRed2);
export default __webpack_public_path__ + "static/media/cross-red-2.7df1fb82df123cc0db32b30660c9f997.svg";
export { ForwardRef as ReactComponent };